import { SVG, SVGProps } from './svg'

export function IconLock(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M18 10V8A6 6 0 0 0 6 8v2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM8 8a4 4 0 1 1 8 0v2H8V8Zm5 10c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-2a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h2Z"
      />
    </SVG>
  )
}
